
<div class="dashboard-content-sec">
    <div class="card mb-0">
        <app-breadcrumb *ngIf="!embedded" [crumbList] = "crumbList"></app-breadcrumb>
        <div class="user-heading-sec">
            <div class="mr-4 d-inline-block">
                <a *ngIf="embedded" id="user-expand" style="width:180px" data-toggle="collapse" class="p-2 fa fa-expand-alt" 
                    href="#userTable" (click)="swapIcon($event)">
                        {{this.total}} Users</a>
                <span *ngIf="!embedded" id="user-expand" class="p-2" href="#">
                        {{this.total}} Users</span>
            </div>

            <div style='width: 140px' class="d-inline-block">
                <a *ngIf="embedded" data-toggle="collapse" href="#newUser" 
                    class="fa fa-user-circle btn btn-default ">
                    Add User
                </a>                        
                <a *ngIf="!embedded" href="javascript:void(0)" [routerLink]="['/admins/user']" 
                    class="btn btn-default fa fa-user-circle">
                    Add User
                </a>     
            </div>  

            <div *ngIf="embedded" id="newUser" class="collapse mt-3">
                <app-user [user_id]="0" [client_id]="client_id" 
                    [partner_id]="partner_id" (submit_return)="collapseUser()">                        
                </app-user>
            </div>                   
            
        </div>

        <div id="userTable" class="table-responsive" [ngClass]="{'collapse': embedded}">
          <div class="loader" *ngIf="showloader">
            <img src="assets/images/loader.gif" alt="">
          </div>
            <table class="table user-table table-striped" >
                <thead>
                    <tr>
                        <th *ngFor="let header of row_header;let i = index" (click)="tableSort(i)">
                            <i *ngIf="header.sort == 'asc' && header.value != ''" class="fa fa-sort-up"></i>
                            <i *ngIf="header.sort == 'desc' && header.value != ''" class="fa fa-sort-down"></i>
                            <i *ngIf="header.sort == null && header.value != ''" class="fa fa-sort"></i> {{header.text}}
                        </th>
                      <th>Delete</th>
                    </tr>
                    <tr *ngIf="!embedded">
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByClient($event)"/>
                            </div>
                        </th>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByLastName($event)"/>
                            </div>
                        </th>
                        <th>
                            <div class="subject-search">
                                <input (change)="filterByEmail($event)"/>
                            </div>
                        </th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let usr of users">
                        <tr>
                        
                            <td *ngIf="!embedded">
                                <a href="javascrpt:void(0);" [routerLink]="['/admins/user',usr.UserID]">
                                    {{usr.client?.ClientName ? usr.client?.ClientName : '-'}}
                                </a>
                            </td>
                            
                            <td>
                                <a *ngIf="!embedded" href="javascrpt:void(0);" [routerLink]="['/admins/user',usr.UserID]">
                                    {{usr.FirstName }} {{usr.LastName}}
                                </a>
                                <a *ngIf="embedded" data-toggle="collapse" (click)="scrollView($event, usr.UserID)" href="#userEdit{{usr.UserID}}">
                                    {{usr.FirstName }} {{usr.LastName}}
                                </a>
                            </td>
                            <td>
                                <a *ngIf="!embedded" href="javascrpt:void(0);" [routerLink]="['/admins/user',usr.UserID]">
                                    {{usr.EMail ? usr.EMail : '-'}}
                                </a>
                                <a *ngIf="embedded" data-toggle="collapse" (click)="scrollView($event, usr.UserID)" href="#userEdit{{usr.UserID}}">
                                    {{usr.EMail ? usr.EMail : '-'}}
                                </a>
                            </td>
        
                            <!-- <td>{{usr.PasswordExpirationDate | date:'hh:mma MM/dd/yyyy'}}</td> -->
                            <td> 
                                <a  *ngIf="!embedded" href="javascrpt:void(0);" [routerLink]="['/admins/user',usr.UserID]">
                                {{this.getRoleType( usr.RoleType )}}
                                </a>
                                <a *ngIf="embedded" data-toggle="collapse" (click)="scrollView($event, usr.UserID)" href="#userEdit{{usr.UserID}}">
                                    {{this.getRoleType( usr.RoleType )}}                              
                                </a>
                            </td>
                            <td>
                                <a *ngIf="!embedded" href="javascrpt:void(0);" [routerLink]="['/admins/user',usr.UserID]">{{usr.Active == 1 ? 'Active' : 'Inactive'}}</a>
                                <a *ngIf="embedded" data-toggle="collapse" (click)="scrollView($event, usr.UserID)" href="#userEdit{{usr.UserID}}">{{usr.Active == 1 ? 'Active' : 'Inactive'}}</a>
                            </td>

                            <td>
                                <div class="d-inline-block">
                                    <a title="Delete" class="btn fa fa-times" (click)="deleteUser(usr.UserID)"> </a>
                                </div>
                            </td>
                        </tr>
                        <tr class="h-0">
                            <td colspan="6" class="p-0 m-0">
                                <div *ngIf="embedded" id="userEdit{{usr.UserID}}" class="collapse user_edit">
                                    <app-user [user_id]="usr.UserID" [client_id]="client_id" [partner_id]="partner_id"
                                       (submit_return)="collapseUser()"></app-user>
                                </div>
                            </td>
                        </tr>
                        <tr class="h-0"></tr>                    

                    </ng-container>
                </tbody>

                <ng-container *ngIf="users?.length == 0">
                  <tr><td colspan="7">No Result Found</td></tr>
                </ng-container>



            </table>
            <div class="has-text-centered align-items-end">
                <ul *ngIf="pager.pages && pager.pages.length && pager.pages.length>1" class="pagination">
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(1)">First</a>
                    </li>
                    <li *ngIf="pager.currentPage !== 1" [ngClass]="{disabled:pager.currentPage === 1}">
                        <a (click)="setPage(pager.currentPage - 1)">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                        <a (click)="setPage(page)">{{page}}</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.currentPage + 1)">Next</a>
                    </li>
                    <li *ngIf="pager.currentPage !== pager.totalPages" [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                        <a (click)="setPage(pager.totalPages)">Last</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
